// src/lib/categories.js
import { db } from '../firebase'
import { doc, getDoc, collection, getDocs } from 'firebase/firestore'

export function slugify(str = "") {
  return String(str)
    .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}


// Normalisation d’un enfant (sous-catégorie)
const normChild = (sc = {}) => ({
  id: sc.id || sc.Id,
  label: String(sc.label || sc.Label || '').trim(),
  // ✅ on garde l’éventuelle image de sous-catégorie si un jour tu en ajoutes
  imageUrl: sc.imageUrl || sc.ImageUrl || '',
})

// Normalisation d’une catégorie top-level
const norm = (c = {}) => ({
  id: c.id || c.Id,
  label: String(c.label || c.Label || '').trim(),
  imageUrl: c.imageUrl || c.ImageUrl || '',     // ✅ important
  children: Array.isArray(c.children)
    ? c.children.map(normChild)
    : [],
})

/**
 * Barre de catégories (navbar) – renvoie toutes les catégories top-level
 * (s’appuie sur le doc unique 'categories/list' ou, en fallback, la collection).
 */
export async function fetchTopCategories() {
  const ref = doc(db, 'categories', 'list')
  const snap = await getDoc(ref)

  if (snap.exists()) {
    const data = Array.isArray(snap.data()?.data) ? snap.data().data : []
    return data
      .map(norm)
      .filter(x => x.id && x.label)
  }

  // fallback: chaque doc dans la collection "categories"
  const col = await getDocs(collection(db, 'categories'))
  return col.docs
    .map(d => norm({ id: d.id, ...d.data() }))
    .filter(x => x.id && x.label)
}

/**
 * Page catégorie – récupère une catégorie avec tous ses children.
 */
export async function fetchCategoryWithChildren(catId) {
  const ref = doc(db, 'categories', 'list')
  const snap = await getDoc(ref)

  if (snap.exists()) {
    const data = Array.isArray(snap.data()?.data) ? snap.data().data : []
    const hit = data.find(
      c => String(c.id || c.Id) === String(catId)
    )
    return hit ? norm(hit) : null
  }

  // fallback: si chaque doc = 1 catégorie (et a un champ children)
  const ref2 = doc(db, 'categories', String(catId))
  const s2 = await getDoc(ref2)
  return s2.exists()
    ? norm({ id: s2.id, ...s2.data() })
    : null
}

/**
 * Top catégories pour la page d’accueil :
 * - limitCats : nombre max de catégories
 * - limitChildren : nombre max de sous-catégories à afficher par carte
 */
export async function fetchFeaturedCategories(limitCats = 6, limitChildren = 4) {
  const ref = doc(db, 'categories', 'list')
  const snap = await getDoc(ref)

  if (!snap.exists()) {
    // fallback léger si jamais le doc unique n’existe pas
    const all = await fetchTopCategories()
    return all
      .slice(0, limitCats)
      .map(c => ({
        ...c,
        children: (c.children || []).slice(0, limitChildren),
      }))
  }

  const raw = Array.isArray(snap.data()?.data) ? snap.data().data : []

  return raw
    .map(norm)
    .filter(c => c.id && c.label)
    .slice(0, limitCats)
    .map(c => ({
      ...c,
      children: (c.children || []).slice(0, limitChildren),
    }))
}
